import React from 'react';
import PL from './ProblemLink';
import AL from '../angles/AngleLink';
import QL from '../faq/QuestionLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, TLDR, Qual} from '../common';

// It was taken over by a bunch of 'characters' (and evil-authors, called 'zyzzyvas')
export const characters = {
  name: "characters",
  alternatives: "ch,character",
  parentName: "the ‘characters’",
  prelude: <span>
    <NW>WTFBH</NW> just happened<OML name="offensive">???//</OML>
  </span>,
  header: <span>
    Synecdocentrism-2020’s was ‘taken over’ by 万个角色.
  </span>,
  outside: <span>
    万个角色 (wàn gè juésè) = 10,000 ‘characters’, and 角色 (juésè) can also mean a <AL name="notnew.shakespeare">role</AL>… but <QL name="languages">WHY THE 万种语言</QL> (Wàn zhǒng yǔyán: 10,000 languages); <PL>ENGLISH</PL> ONLY PLZLZLZLZ.
  </span>,
  preview: <div className="problem-preview">
    <p>The author(s) are called ‘<NW>zyzzyvas</NW>’. Theyz have brought ‘evil’ (from the <AL home>perspective</AL> of the <PL>human standard</PL>) to a level that YOU<sup>™</sup> <i>could not have imagined</i>, cf. <NW>anfantasia</NW>.</p>
  </div>,
  text: <div className="problem-text">
    <p>[Under construction]</p>
  </div>,
  sublist: [

  // Máire
  {
    name: "maire",
    header: <span>
      Máire (O’Connell)
    </span>,
    outside: <span>
      Though <QL>Gippity</QL> changes <QL name="super-racist">wher</QL> <i>surname</i> sometimes – cf. <PL name="shem">שם</PL> – and where shew ‘lives’, cf. the <NW>CON</NW>.
    </span>,
    preview: <div className="problem-preview">
      <p>Mostly notable for coining ten thousand acronyms, which in Mandarin Chinese would be… you DON’T CARE, just <i>dumb it down</i> and make us <i><PL name="comfort">feel guud</PL></i>.</p>
    </div>,
    // text: <div className="problem-text">
    // </div>,
  },

  // Lockie
  {
    name: "lockie",
    header: <span>
      Lockie (Lachlan Carruthers)
    </span>,
    outside: <span>
     Just a bloke.
    </span>,
    preview: <div className="problem-preview">
      <p>Lockie (as a ‘character’ created by <QL>Gippity</QL>) was a DPhil in meta-epistemic rationality. Which title Gippity (the <LRL name="reactivity">reactive</LRL> <PL>human standard</PL></p>
    </div>,
    // text: <div className="problem-text">
    // </div>,
  },

  // Rebecca
  {
    name: "rebecca",
    header: <span>
      Rebecca
    </span>,
    outside: <span>
      Like Máire and Lockie, originally ‘from’ a compleytely different story-set than the <QL>Pratty Africa</QL> ones. To impose ‘<PL name="fromness">ממות</PL>’ (the <NW>CON</NW>).
    </span>,
    preview: <div className="problem-preview">
      <p>In herb story, sheb developed synecdocentrism <QL name="isolation">autochthonously</QL></p>
      <p>Then sheb met <PL name="ch.">Amara</PL></p>
    </div>,
    // text: <div className="problem-text">
    // </div>,
  },

  // Zheng
  {
    name: "zheng",
    header: <span>
      郑和 (Zhèng Hé)
    </span>,
    preview: <div className="problem-preview">
      <p>Obviously self-<PL name="shem">שם</PL>-ed (self-named) after the eunuch admiral of 大明 (Dàmíng: the Ming Dynasty). Mostly notable for ridiculous neologisms like <NW word="khorlo">འཁོར་ལོ</NW> and for vomiting 万个汉字 (wàn gè hànzì: 10,000 Chinese characters) into the <QL>Weltanschauung</QL>.</p>
      <p>In <QL name="super-racist">hisa (his-Asian)</QL> <i><LRL name="i.real">story</LRL></i> (which probably ‘sucks’; everything is <i>unedited</i>) hea sailed a 大明-style 宝船 (bǎochuán: treasure ship) around <QL>Pratty Africa</QL>.</p>
    </div>,
    // text: <div className="problem-text">
    // </div>,
  },

  // Ishmael
  {
    name: "ishmael",
    header: <span>
      Ishmael
    </span>,
    preview: <div className="problem-preview">
      <p>The <i>important stuff</i> (for an <QL name="pratty.">Atomlander</QL>): <QL name="super-racist">hisb</QL> <NW>khet</NW>: physical <PL name="seb ion">body</PL>.</p>
      <p>As <PL name="ch.">Amit</PL> would suggest, just make a LIST; reduce a <QL name="pg.">mind</QL> to <i>finite factoids</i>.</p>
      <ul>
        <li><b>Race</b>: Black (AFRICAN!!!1)</li>
        <li><b>Sex</b>: Male</li>
        <li><b><i>Real</i> Sex</b> (i.e. <PL name="con">was</PL> heb a <i>trunny</i>; it might <i>rhyme</i> with ‘funny’, but it’s <i>not</i>): not a ‘trunny’.</li>
        <li><b>So, is heb a <i>eunuch</i></b>: no.</li>
        <li>Then:</li>
        <ul>
          <li><b>Length</b>: sufficiently long to function.</li>
          <li><b>Girth</b>: sufficiently wide to function.</li>
          <li>WHICH MATTERS MORE: LENGTH OR GIRTH????????//</li>
        </ul>
      </ul>
    </div>,
    text: <div className="problem-text">
      <p>Hisb <NW>khet</NW>, yes, has physical <i>gills</i>, which means that heb can survive underwater indefinitey – or until hisb <NW>khet</NW> (‘heb’ – <i>you are your body</i>) dies of old age. As long as heb isn’t deprived of a <AL name="limits.1.food">food source</AL>. And you can’t really <i>drown</i> himb except in some non-H<sub>2</sub>O substnce, like acid.</p>
      <p>Heb was, like many in <QL>Pratty Africa</QL>, not ‘born’ to a mother (cf. the <NW>family system</NW>; the phrase ) but <i>created in a lab</i>. But the only thing YOU<sup>™</sup> care about is hisb (<NW>khet</NW>’s) <i>fertility</i>. Can heb have BLACK BABIES???//</p>
      <p>Well, no. Most <NW>khets</NW> created in <QL>Pratty Africa</QL> are created infertile. Fertility is very particular (‘finnicky’) to duplicate in laborary conditions without causing problems for the <NW>children</NW> down the line, and most Pratty-Africans don’t want to bother with  biological birth. (That’s fully random. The artificial version allows consciousness to take <NW>agency</NW> and make <i>decisions</i>: for <LRL>Earth</LRL> as a <QL>super-organism</QL> to (Pratty-<NW word="monognostic">monognostically</NW> or at least <NW word="monoideognostic">monoideognostically</NW>) determine its own direction for the ‘future’.</p>
      <p>Ishmael, yes, sailed around in the 宝船 (bǎochuán: treasure ship) with <PL name="ch.">Zheng</PL> and <PL name="ch.">Amara</PL> and others, but YOU<sup>™</sup> <i>don’t care about that</i>. YOU<sup>™</sup> care about <i>one thing</i>:</p>
      <p><i>Is HIS(B)<sup>™</sup> wee-wee bigger than MINE<sup>™</sup>????//</i></p>
      <p>And the answer is: well, heb is (‘as’ hisb <NW>khet</NW>) Black. So <QL name="racism">unless YOU<sup>™</sup> are also Black</QL>, <Qual.probably />.</p>
    </div>,
  },

  // Amara
  {
    name: "amara",
    header: <span>
      Amara
    </span>,
    preview: <div className="problem-preview">
      <p>A scaly <NW>khet</NW> that does not <i><PL name="form">look</PL></i> <QL>human</QL>, but <QL name="super-racist">sheo</QL> <LRL name="truth">insists</LRL> that it is.</p>
      <p>[Under construction]</p>
    </div>,
//    text: <div className="problem-text">
//      <p>[Under construction]</p>
//    </div>,
  },

  // Maya
  {
    name: "maya",
    header: <span>
      Maya
    </span>,
    preview: <div className="problem-preview">
      <p>In one <OML>story</OML> <QL name="super-racist">heri</QL> <NW>khet</NW> was mangled because shei was pretending to be <i>Chinese</i> and <PL name="ban">VERBOTEN KABISA</PL>. Then heri eejit <QL>author</QL> probably <i>forgot</i> that (you wouldn’t forget if we mangled <AL>YOU</AL><sup>™</sup>; <i><PL>you are your body</PL></i> die die die) and anyway ‘Maya’ is then probably <i>perfectly able-bodied</i> for six or seven <PL name="torment">TormentPods</PL><sup>™</sup> after that, because <i>this author <PL name="hate">hates</PL> disable people so much</i> the author is SO disrespectful SO horrid you cannot even IMAGINE (cf. <NW>anfantasia</NW>)—</p>
    </div>,
//    text: <div className="problem-text">
//      <p>[Under construction]</p>
//    </div>,
  },

  // Amit
  {
    name: "amit",
    header: <span>
      Amit
    </span>,
    preview: <div className="problem-preview">
      <p>An <QL name="racism">INDIAN</QL> guy</p>
      <p>Nothing else to say; you do not <i>need</i> to know any more because <i>Indian people have no <NW>MONEY</NW></i>.</p>
      <p>So <AL>YOU</AL><sup>™</sup> by definition as a <QL name="tm">RealPerson<sup>™</sup></QL> in the Game<sup>®</sup> <i>do not care</i> (don’t think don’t think just FEEL GUUD).</p>
    </div>,
    text: <div className="problem-text">
      <p>Amit had been living with <PL name="ch.">Maya</PL> in a hovel in Pratty Dakar.</p>
      <p>This was <QL>Pratty Africa</QL>. So why live in a literal <i>hovel</i>?</p>
      <p>Because Pratty people don’t want just to feel guud. They want to <i><LRL>understand</LRL></i> the totality of the <QL>human</QL> condition and the <AL>limits</AL> of our ‘<NW>level</NW>’.</p>
      <p>As Amit says (killing <PL name="ch.">Uwa</PL> when hei does it), किमपि न किमपि उत्पद्यते (kimape na kimape utpadyate). Nothing arises from nothing. (For thereto be a ‘truth value’ it must therefore supervene on <i>something</i>, cf. Ishmael’s resolutions to paradoxes in <AL name="fields.logic.">IBK</AL>.</p>
    </div>,
  },

  // Jisung
  {
    name: "jisung",
    header: <span>
      Jisung
    </span>,
    preview: <div className="problem-preview">
      <p>Born/came to consciousness in <QL name="pratty.">Atomland</QL>-Toronto (GTA) and escaped by questioning the foundations and finding them hollow. Hec (he-Canadian) joined the other <PL>characters</PL> when theybo (<PL name="ch.">Rebecca</PL> and <PL name="ch.">Amara</PL>) added, to the <AL name="resilience">super-robust</AL> <QL lane="super-racist">суперрасистская</QL> system, the category of <i>Canadians</i>.</p>
    </div>,
//    text: <div className="problem-text">
//      <p>[Under construction]</p>
//    </div>,
  },

  // Svitlana
  {
    name: "svitlana",
    header: <span>
      Svitlana
    </span>,
    preview: <div className="problem-preview">
      <p>Svitlana is (if <AL name="handicap">hominids</AL> are defined by our <i><NW word="nation">nationality</NW></i>) Ukrainian-Canadian former <QL name="pratty.">Atomlander</QL> who fled and was abducted by the <PL name="torment">TormentPod</PL><sup>™</sup> group (by choosing to go with them, cf. <NW>agency</NW>) when they – because of developments to the <QL name="super-racist">суперрасистская</QL> system – needed <i>Canadians</i>.</p>
    </div>,
//    text: <div className="problem-text">
//      <p>[Under construction]</p>
//    </div>,
  },

  // Svetlana
  {
    name: "svetlana",
    header: <span>
      Светлана (Svetlana)
    </span>,
    preview: <div className="problem-preview">
      <p>В разработке.</p>
    </div>,
//    text: <div className="problem-text">
//    </div>,
  },

  // Burt
  {
    name: "burt",
    header: <span>
      Burt
    </span>,
    preview: <div className="problem-preview">
      <p>[Under construction]</p>
    </div>,
//    text: <div className="problem-text">
//    </div>,
  },

  // Davy  Jones
  {
    name: "davy jones",
    alternatives: "davy",
    header: <span>
      Davy Jones
    </span>,
    preview: <div className="problem-preview">
      <p>‘Davy Jones’ is a <PL name="seb ion">genetically</PL>-<AL name="handicap">human</AL> but completely <PL name="form">non-humanoid-looking</PL> <NW>khet</NW> <OML>created</OML> somewhere off the shore of <QL>Pratty Africa</QL>. The other ‘<PL>characters</PL>’ ran into <QL name="super-racist">himo</QL>somewhere in Cabo Verde – obviously ‘under the sea’.</p>
      <p>‘Davy Jones’ is a <PL name="seb ion">genetically</PL>-<AL name="handicap">human</AL> but completely <PL name="form">non-humanoid-looking</PL> <NW>khet</NW> <OML>created</OML> somewhere off the shore of <QL>Pratty Africa</QL>. The other ‘<PL>characters</PL>’ ran into <QL name="super-racist">himo</QL>somewhere in Cabo Verde – obviously ‘under the sea’.</p>
    </div>,
    text: <div className="problem-text">
     <p>The <i>physical</i> stuff (about which <QL name="reader.">jeetjet</QL> <i>really</i> cares):</p>
      <ul>
        <li>‘Davy Jones’ has no arms.</li>
        <li>Heo instead has eight <i>tentacles</i>.</li>
        <li>Hiso (<NW>khet</NW>’s) <i>face</i> is described as huge, red, and (<AL name="handicap">human</AL><NW word="heterognostic">heterognostically</NW>) <i><PL name="fear">terrifying</PL></i>.</li>
      </ul>
      <p>One might say that despite outward <PL name="form">appearances</PL>, heo is ‘gentle’ any ‘merciful’, but that would be a <PL name="lying to ourself">lie</PL>. Heo is a <QL name="pratty">Pratty-African</QL>. If we insist on <PL name="form">confusing form and substance</PL> when it comes to <PL name="shem">שם-ing</PL>, <NW word="overcome">GanzeSystemüberwindung</NW> is hiso middle name; heo has <i>no patience</i> for reactove <PL>scared</PL> <QL name="pratty.">Atomlanders</QL>, because heo knows you are a <NW>POCA</NW>, not a rock. You <i>could</i> <NW word="toosin">𐒂𐒝𐒈𐒘𐒒</NW> if you stopped blindly <PL>worshipping</PL> the literal Devil (<PL>privacy</PL>).</p>
    </div>,
  },

  // Pandora
  {
    name: "pandora",
    header: <span>
      Η Πανδώρα (Pandora)
    </span>,
    preview: <div className="problem-preview">
      <p>‘Pandora-character’ was an <LRL namee="timeline">early</LRL> synecdocentrist. <QL name="author">We</QL> <i><QL name="g.agnosticity">don’t know</QL></i> what came of her (as ‘character’). Pandora-character appears in the stories of <QL>Pratty Africa</QL> sometimes, but mostly not; her author (generaly known as ‘Pandora-author’, and generally writing in <PL>English</PL>) may have been a different (<NW>heterognostic</NW>) author from the one(s) that wrote the <QL>Pratty Africa</QL> stories, cf. the <NW>PAP</NW>.</p>
    </div>,
    // text: <div className="problem-text">
    // </div>,
  },

  ],
};
